var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "风险订单审核",
        visible: _vm.dialogVisible,
        width: "500px",
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "auditForm",
          attrs: {
            model: _vm.auditForm,
            rules: _vm.auditRules,
            "label-width": "80px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "审核状态", prop: "reviewStatus" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    clearable: "",
                    size: "small",
                    placeholder: "请选择",
                  },
                  model: {
                    value: _vm.auditForm.reviewStatus,
                    callback: function ($$v) {
                      _vm.$set(_vm.auditForm, "reviewStatus", $$v)
                    },
                    expression: "auditForm.reviewStatus",
                  },
                },
                [
                  _c("el-option", { attrs: { label: "订单通过", value: "1" } }),
                  _c("el-option", { attrs: { label: "订单拦截", value: "2" } }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "备注说明", prop: "remarks" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: "200",
                  "show-word-limit": "",
                  placeholder: "请输入",
                  resize: "none",
                },
                model: {
                  value: _vm.auditForm.remarks,
                  callback: function ($$v) {
                    _vm.$set(_vm.auditForm, "remarks", $$v)
                  },
                  expression: "auditForm.remarks",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", loading: _vm.loading },
              on: { click: _vm.submitAudit },
            },
            [_vm._v("确 定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }